import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Application render error", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
        <section
          className="w-full max-w-lg rounded-2xl bg-white p-8 text-center shadow-lg"
          role="alert"
          aria-live="assertive"
        >
          <h1 className="text-2xl font-semibold text-slate-900">This page could not load</h1>
          <p className="mt-3 text-slate-600">
            Your information is safe. Reload the latest version of MediGenie and try again.
          </p>
          <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
            <button
              type="button"
              className="rounded-lg bg-blue-600 px-5 py-3 font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              onClick={() => window.location.reload()}
            >
              Reload MediGenie
            </button>
            <a
              href="/login"
              className="rounded-lg border border-slate-300 px-5 py-3 font-medium text-slate-700 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Go to sign in
            </a>
          </div>
        </section>
      </main>
    );
  }
}
